<template>
  <div class="permission-denied-container">
    <img
      class="img-responsive center-block"
      :src="IMAGE_ACCESS_DENIED"
      alt="Access denied"
    />
    <h3>Organization management only</h3>
    <p>This area is for viewing the organization's {{ reportText }} report. {{ personalText }}</p>
    <slot></slot>
  </div>
</template>

<script>
import { IMAGE_ACCESS_DENIED } from '~/rails_assets';

export default {
  name: 'ReportPermissionDenied',
  props: {
    reportText: { type: String },
    personalText: { type: String, default: 'The personal report is under the "Me" tab.' },
  },
  data() {
    return {
      IMAGE_ACCESS_DENIED,
    };
  },
};
</script>
